import { DestroyRef, Injectable, inject } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { NavigationError, Router } from '@angular/router'

import { filter } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class NavigationErrorHandlerService {
  #router = inject(Router)
  #destroyRef = inject(DestroyRef)

  init(): void {
    this.#router.events
      .pipe(
        filter((error) => error instanceof NavigationError),
        takeUntilDestroyed(this.#destroyRef)
      )
      .subscribe(({ error }) => this.#handleError(error))
  }

  #handleError(error: any): void {
    const message = error?.message ?? ''
    const isChunkError =
      error?.name === 'ChunkLoadError' ||
      message.includes('Loading chunk') ||
      message.includes('Failed to fetch dynamically imported module')

    if (isChunkError) {
      window.location.reload()
    }
  }
}
